export default __webpack_public_path__ + "static/media/04_Phase2.38492e79.png";